import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
	Typography,
	Divider,
	Grid,
	Table,
	TableBody,
	TableRow,
	TableCell,
	TableContainer,
	Paper,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import LoanCalculation from './LoanCalculation';
import { loanAction } from '../../redux/actions/applicationAction';

const useStyles = makeStyles(theme => ({
	tableCell: {
		fontWeight: 'bold',
	},
}));

const ReviewDetails = ({
	maritalStatus,
	employerName,
	profession,
	salarynet,
	homeAddress,
	employmentType,
	workCertificate,
	district,
	districtQuestion,
	district2,
	isGuardian,
	guardianCertificate,
	maritalStatusCertificate,
	spouseNationalId,
	spousePhone,
	spouseHomeAddress,
	spouseEmployerName,
	spouseProfession,
	spouseSalarynet,
	spouseEmploymentType,
	spouseWorkCertificate,
	houseRangeId,
	bankProviderId1,
	bankQuestion,
	bankProviderId2,
	houseCategoryId1,
	houseQuestion,
	houseCategoryId2,
	meetDownCapacity,
	insured,
	householdDisability,
	ownResidentialUnit,
	province,
	districtLocation,
	sector,
	cell,
	village,
	spouseProvince,
	spouseDistrict,
	spouseSector,
	spouseCell,
	spouseVillage,
}) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const dispatch = useDispatch();

	const loan = useSelector(state => state.loan);

	const totalIncome = Number(salarynet) + Number(spouseSalarynet);
	useEffect(() => {
		dispatch(loanAction({ totalIncome }));
	}, []);
	return (
		<div>
			<Typography variant='h4' color='initial'>
				{t('review-details')}
			</Typography>
			<Divider />
			<Grid container spacing={4} style={{ marginTop: 15 }}>
				<Grid item xs={12} sm={12} md={4}>
					<Typography variant='h6'>{t('applicant-details')}</Typography>
					<TableContainer component={Paper}>
						<Table>
							<TableBody>
								<TableRow>
									<TableCell className={classes.tableCell}>
										{t('disability-question')}
									</TableCell>
									<TableCell>{householdDisability}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.tableCell}>
										{t('province')}
									</TableCell>
									<TableCell>{province}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.tableCell}>
										{t('home-district')}
									</TableCell>
									<TableCell>{districtLocation}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.tableCell}>
										{t('sector')}
									</TableCell>
									<TableCell>{sector}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.tableCell}>
										{t('cell')}
									</TableCell>
									<TableCell>{cell}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.tableCell}>
										{t('village')}
									</TableCell>
									<TableCell>{village}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.tableCell}>
										{t('income')}
									</TableCell>
									<TableCell>{salarynet.toLocaleString()}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.tableCell}>
										{t('employment-status')}
									</TableCell>
									<TableCell>{employmentType}</TableCell>
								</TableRow>
								<TableRow>
									{employmentType === 'Self-Employed' ||
									employmentType === 'Employed' ? (
										<>
											<TableCell className={classes.tableCell}>
												{t('work-certificate')}
											</TableCell>
											<TableCell>{workCertificate.name}</TableCell>
										</>
									) : null}
								</TableRow>
								{maritalStatus === 'Single' && employmentType === 'Employed' ? (
									<>
										<TableRow>
											<TableCell className={classes.tableCell}>
												{t('employer')}
											</TableCell>
											<TableCell>{employerName}</TableCell>
										</TableRow>
										<TableRow>
											<TableCell className={classes.tableCell}>
												{t('profession')}
											</TableCell>
											<TableCell>{profession}</TableCell>
										</TableRow>
									</>
								) : maritalStatus === 'Single' &&
								  employmentType === 'Self-Employed' ? (
									<TableRow>
										<TableCell className={classes.tableCell}>
											{t('profession')}
										</TableCell>
										<TableCell>{profession}</TableCell>
									</TableRow>
								) : null}

								<TableRow>
									{maritalStatus === 'Single' ? (
										<>
											<TableCell className={classes.tableCell}>
												{t('single-certificate')}
											</TableCell>
											<TableCell>{maritalStatusCertificate.name}</TableCell>
										</>
									) : null}
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
				{maritalStatus === 'Married' && (
					<Grid item xs={12} sm={12} md={4}>
						<Typography variant='h6'>{t('spouse-details')}</Typography>
						<TableContainer component={Paper}>
							<Table>
								<TableBody>
									<TableRow>
										<TableCell className={classes.tableCell}>
											{t('id-number')}
										</TableCell>
										<TableCell>{spouseNationalId}</TableCell>
									</TableRow>
									<TableRow>
										<TableCell className={classes.tableCell}>
											{t('phone')}
										</TableCell>
										<TableCell>{spousePhone}</TableCell>
									</TableRow>
									<TableRow>
										<TableCell className={classes.tableCell}>
											{t('province')}
										</TableCell>
										<TableCell>{spouseProvince}</TableCell>
									</TableRow>
									<TableRow>
										<TableCell className={classes.tableCell}>
											{t('home-district')}
										</TableCell>
										<TableCell>{spouseDistrict}</TableCell>
									</TableRow>
									<TableRow>
										<TableCell className={classes.tableCell}>
											{t('sector')}
										</TableCell>
										<TableCell>{spouseSector}</TableCell>
									</TableRow>
									<TableRow>
										<TableCell className={classes.tableCell}>
											{t('cell')}
										</TableCell>
										<TableCell>{spouseCell}</TableCell>
									</TableRow>
									<TableRow>
										<TableCell className={classes.tableCell}>
											{t('village')}
										</TableCell>
										<TableCell>{spouseVillage}</TableCell>
									</TableRow>
									<TableRow>
										{spouseEmployerName ? (
											<>
												<TableCell className={classes.tableCell}>
													{t('employer')}
												</TableCell>
												<TableCell>{spouseEmployerName}</TableCell>
											</>
										) : null}
									</TableRow>
									<TableRow>
										{spouseEmployerName ? (
											<>
												<TableCell className={classes.tableCell}>
													{t('profession')}
												</TableCell>
												<TableCell>{spouseProfession}</TableCell>
											</>
										) : null}
									</TableRow>
									<TableRow>
										{spouseEmployerName ? (
											<>
												<TableCell className={classes.tableCell}>
													{t('income')}
												</TableCell>
												<TableCell>{spouseSalarynet}</TableCell>
											</>
										) : null}
									</TableRow>
									<TableRow>
										<TableCell className={classes.tableCell}>
											{t('employment-status')}
										</TableCell>
										<TableCell>{spouseEmploymentType}</TableCell>
									</TableRow>
									<TableRow>
										{spouseEmploymentType === 'Self-Employed' ||
										spouseEmploymentType === 'Employed' ? (
											<>
												<TableCell className={classes.tableCell}>
													{t('work-certificate')}
												</TableCell>
												<TableCell>{spouseWorkCertificate.name}</TableCell>
											</>
										) : null}
									</TableRow>
									<TableRow>
										<TableCell className={classes.tableCell}>
											{t('marriage-certificate')}
										</TableCell>
										<TableCell>{maritalStatusCertificate.name}</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</TableContainer>
					</Grid>
				)}
				<Grid item xs={12} sm={12} md={4}>
					<Typography variant='h6'>{t('loan-details')}</Typography>
					<TableContainer component={Paper}>
						<Table>
							<TableBody>
								<TableRow>
									<TableCell className={classes.tableCell}>
										{t('house-range')}
									</TableCell>
									<TableCell>{houseRangeId.name}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.tableCell}>
										{t('capacity-question')}
									</TableCell>
									<TableCell>{meetDownCapacity}</TableCell>
								</TableRow>
								{meetDownCapacity === 'No' ? (
									<TableRow>
										<TableCell className={classes.tableCell}>
											{t('insurance-question')}
										</TableCell>
										<TableCell>{insured}</TableCell>
									</TableRow>
								) : null}

								<TableRow>
									<TableCell className={classes.tableCell}>
										{t('house-category')}
									</TableCell>
									<TableCell>{houseCategoryId1.name}</TableCell>
								</TableRow>
								<TableRow>
									{houseCategoryId2 ? (
										<>
											<TableCell className={classes.tableCell}>
												{t('house-category2')}
											</TableCell>
											<TableCell>{houseCategoryId2.name}</TableCell>
										</>
									) : null}
								</TableRow>
								<TableRow>
									<TableCell className={classes.tableCell}>
										{t('district')}
									</TableCell>
									<TableCell>{district}</TableCell>
								</TableRow>
								<TableRow>
									{district2 ? (
										<>
											<TableCell className={classes.tableCell}>
												{t('second-district')}
											</TableCell>
											<TableCell>{district2}</TableCell>
										</>
									) : null}
								</TableRow>
								<TableRow>
									<TableCell className={classes.tableCell}>
										{t('loan-provider')}
									</TableCell>
									<TableCell>{bankProviderId1.name}</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
				<Grid item xs={12} sm={12} md={4}>
					<Typography variant='h6'>{t('loan-summary')}</Typography>
					<LoanCalculation loan={loan} />
				</Grid>
			</Grid>
		</div>
	);
};

export default ReviewDetails;
